import { useEffect, useState } from "react";
import urlApi from "shared/actions/urlApi";

export const FIELDS_OF_STUDY = [
  { label: 'Коммуникационный дизайн. Базовый уровень', value: 'MagHseComDes2025' },
  { label: 'Гейм-дизайн. Базовый уровень', value: 'MagHseGameDes2025' },
  { label: 'Анимационное производство', value: 'MagHseAnim2025' },
  { label: 'Дизайн и продвижение цифрового продукта', value: 'MagHseDigProd2025' },
  { label: 'Анимация', value: 'MagHseAnimAdv2025' },
  { label: 'Арт-дирекшн', value: 'MagHseArtDir2025' },
  { label: 'Иллюстрация и комикс', value: 'MagHseIllCom2025' },
  { label: 'Искусство книги', value: 'MagHseBookArt2025' },
  { label: 'Концепт-дизайн', value: 'MagHseConcept2025' },
  { label: 'Медиа и дизайн', value: 'MagHseMedDes2025' },
  { label: 'Моушн-дизайн', value: 'MagHseMotion2025' },
  { label: 'Предметный и промышленный дизайн', value: 'MagHseObjIndDes2025' },
  { label: 'Системный гейм-дизайн', value: 'MagHseSysGame2025' },
  { label: 'Создание фэшн-бренда', value: 'MagHseFashBrand2025' },
  { label: 'Арт-дирекшн в моде', value: 'MagHseFashArtDir2025' },
  { label: 'Практики современного искусства', value: 'MagHseContArt2025' },
  { label: 'Видеоарт', value: 'MagHseVidArt2025' },
  { label: 'Современная живопись', value: 'MagHseContPaint2025' },
  { label: 'Фотография', value: 'MagHsePhoto2025' },
  { label: 'Sound Art & Sound Studies', value: 'MagHseSoundArt2025' },
  { label: 'Практики кураторства в современном искусстве', value: 'MagHseCuratorArt2025' },
  { label: 'Кураторство и критика в моде', value: 'MagHseCuratorFashion2025' },
  { label: 'Дизайн архитектурной среды', value: 'MagHseArchEnv2025' },
  { label: 'Дизайн интерьера', value: 'MagHseIntDes2025' },
  { label: 'Дизайн и продвижение цифрового продукта. Онлайн', value: 'MagHseDigProdOnline2025' },
  { label: '3D-постпродакшн. Онлайн', value: 'MagHse3DPostOnline2025' },
  { label: 'Современные технологии преподавания дизайна и искусства', value: 'MagHseDesArtTech2025' },
  { label: 'Управление в креативных индустриях. Онлайн', value: 'MagHseCreatIndMan2025' },
  { label: 'Коммуникационный дизайн. Базовый уровень. Санкт-Петербург', value: 'MagHseComDesSPB2025' },
  { label: 'Арт-дирекшн культурных институций. Санкт-Петербург', value: 'MagHseArtDirCultSPB2025' },
  { label: 'Дизайн интерьера. Санкт-Петербург', value: 'MagHseIntDesSPB2025' },
  { label: 'Art direction for cultural institutions. Saint Petersburg', value: 'MagHseArtDirCultSPBENG2025' },
];

export const FIELDS_OF_STUDY_TITLE_INDEX: Record<string, string> = FIELDS_OF_STUDY.reduce((acc, { label, value}) => {
  return {
    ...acc,
    [value]: label,
  }
},{})


export const FILEDS_OF_STUDY_VALUES = Object.keys(FIELDS_OF_STUDY_TITLE_INDEX);

export const useProTagsFromAPI = () => {
  const [proTags, setProTags] = useState<string[]>([]);

  useEffect(() => {
    urlApi()
      .getLendPresTagsTree('ru')
      .then((tree) => {
        const root = tree?.[0];
        const tags = root?.additionalTags || [];
        const ids = tags.map((tag: any) => tag.tagId);
        setProTags(ids);
      })
      .catch((err) => {
        console.error('Не удалось загрузить proTags', err);
      });
  }, []);

  return proTags;
};import { useEffect, useState } from "react";
import urlApi from "shared/actions/urlApi";

export const FIELDS_OF_STUDY = [
  { label: 'Коммуникационный дизайн. Базовый уровень', value: 'MagHseComDes2025' },
  { label: 'Гейм-дизайн. Базовый уровень', value: 'MagHseGameDes2025' },
  { label: 'Анимационное производство', value: 'MagHseAnim2025' },
  { label: 'Дизайн и продвижение цифрового продукта', value: 'MagHseDigProd2025' },
  { label: 'Анимация', value: 'MagHseAnimAdv2025' },
  { label: 'Арт-дирекшн', value: 'MagHseArtDir2025' },
  { label: 'Иллюстрация и комикс', value: 'MagHseIllCom2025' },
  { label: 'Искусство книги', value: 'MagHseBookArt2025' },
  { label: 'Концепт-дизайн', value: 'MagHseConcept2025' },
  { label: 'Медиа и дизайн', value: 'MagHseMedDes2025' },
  { label: 'Моушн-дизайн', value: 'MagHseMotion2025' },
  { label: 'Предметный и промышленный дизайн', value: 'MagHseObjIndDes2025' },
  { label: 'Системный гейм-дизайн', value: 'MagHseSysGame2025' },
  { label: 'Создание фэшн-бренда', value: 'MagHseFashBrand2025' },
  { label: 'Арт-дирекшн в моде', value: 'MagHseFashArtDir2025' },
  { label: 'Практики современного искусства', value: 'MagHseContArt2025' },
  { label: 'Видеоарт', value: 'MagHseVidArt2025' },
  { label: 'Современная живопись', value: 'MagHseContPaint2025' },
  { label: 'Фотография', value: 'MagHsePhoto2025' },
  { label: 'Sound Art & Sound Studies', value: 'MagHseSoundArt2025' },
  { label: 'Практики кураторства в современном искусстве', value: 'MagHseCuratorArt2025' },
  { label: 'Кураторство и критика в моде', value: 'MagHseCuratorFashion2025' },
  { label: 'Дизайн архитектурной среды', value: 'MagHseArchEnv2025' },
  { label: 'Дизайн интерьера', value: 'MagHseIntDes2025' },
  { label: 'Дизайн и продвижение цифрового продукта. Онлайн', value: 'MagHseDigProdOnline2025' },
  { label: '3D-постпродакшн. Онлайн', value: 'MagHse3DPostOnline2025' },
  { label: 'Современные технологии преподавания дизайна и искусства', value: 'MagHseDesArtTech2025' },
  { label: 'Управление в креативных индустриях. Онлайн', value: 'MagHseCreatIndMan2025' },
  { label: 'Коммуникационный дизайн. Базовый уровень. Санкт-Петербург', value: 'MagHseComDesSPB2025' },
  { label: 'Арт-дирекшн культурных институций. Санкт-Петербург', value: 'MagHseArtDirCultSPB2025' },
  { label: 'Дизайн интерьера. Санкт-Петербург', value: 'MagHseIntDesSPB2025' },
  { label: 'Art direction for cultural institutions. Saint Petersburg', value: 'MagHseArtDirCultSPBENG2025' },
];

export const FIELDS_OF_STUDY_TITLE_INDEX: Record<string, string> = FIELDS_OF_STUDY.reduce((acc, { label, value}) => {
  return {
    ...acc,
    [value]: label,
  }
},{})


export const FILEDS_OF_STUDY_VALUES = Object.keys(FIELDS_OF_STUDY_TITLE_INDEX);

export const useProTagsFromAPI = () => {
  const [proTags, setProTags] = useState<string[]>([]);

  useEffect(() => {
    urlApi()
      .getLendPresTagsTree('ru')
      .then((tree) => {
        const root = tree?.[0];
        const tags = root?.additionalTags || [];
        const ids = tags.map((tag: any) => tag.tagId);
        setProTags(ids);
      })
      .catch((err) => {
        console.error('Не удалось загрузить proTags', err);
      });
  }, []);

  return proTags;
};